export default __webpack_public_path__ + "static/aerating-27b1882740cb257fc45de5354745ecee.webp";